import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { SessionProvider } from "./ui/context/SessionContext";
import { TranscriptionProvider } from "./ui/context/TranscriptionContext";
import "./ui/global.css";

if (typeof document !== "undefined") {
	const rootElement = document.getElementById("root");
	if (rootElement) {
		ReactDOM.createRoot(rootElement).render(
			<React.StrictMode>
				<SessionProvider>
					<TranscriptionProvider>
						<App />
					</TranscriptionProvider>
				</SessionProvider>
			</React.StrictMode>,
		);
	}
}
